export const navItems = ['Destinations', 'Space Trains', 'Pricing', 'Packages'];

export const col1 = ['About Us', ' Destinations', 'Spacecraft'];
export const col2 = ['Terms of Service', 'Privacy Policy', 'Refund Policy'];
export const col3 = ['News', 'Travel'];
export const social = [
  '/img/facebook.svg',
  '/img/instagram.svg',
  '/img/twitter.svg',
  '/img/linkedin.svg',
];

export const sections = [
  {
    image: '/img/unsplash7.jpg',
    title: 'Explore Space Trips',
    body: 'Journey to the Red Planet and uncover the mysteries of Mars. Walk on Martian soil and witness stunning landscapes.',
    variant: 'primary',
    buttonText: 'Learn More',
  },
  {
    image: '/img/unsplash5.jpg',
    title: 'Our Space Train Fleet',
    body: 'Travel in style and comfort aboard our luxury space trains. Our fleet is equipped with cutting-edge technology to ensure a safe and unforgettable cosmic journey',
    variant: 'primary',
    buttonText: 'View Destinations',
    flip: true,
  },
];

export const cards = [
  {
    image: '/img/unsplash2.jpeg',
    title: 'Luxury Space Trains',
    body: 'Discover our exquisite fleet of space trains, each designed for the utmost comfort and safety during your cosmic journey.',
    buttonText: 'View Fleet',
    variant: 'primary',
  },
  {
    image: '/img/unsplash7.jpg',
    title: 'Interstellar Express',
    body: 'Experience the thrill of space travel on our Interstellar Express. Journey to distant galaxies in unparalleled luxury and comfort',
    buttonText: 'Learn More',
    variant: 'primary',
  },
  {
    image: '/img/unsplash4.jpg',
    title: 'Mars Expedition',
    body: 'Embark on a thrilling journey to the Red Planet. Explore Martian landscapes, visit historic landing sites, and learn about the mysteries of Mars',
    buttonText: 'Learn More',
    variant: 'primary',
  },
];
